import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AssocDistrAuth } from '@hm_app/@core/models/utente';

@Component({
    selector: 'ngx-auth-detail',
    templateUrl: './auth-detail.component.html',
    styleUrls: ['./auth-detail.component.scss'],
})
export class AuthDetailComponent implements OnInit {

    @Input()
    autorizzazione: any;

    @Input()
    nome: string;

    @Input()
    ruolo: string;

    @Input()
    dettaglio: string;



    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    associazione_auth_distretti: AssocDistrAuth;


    constructor() { }

    ngOnInit() {
        // console.log("associazione_auth_distretti", this.associazione_auth_distretti)
    }

    doChangeStatus(autorizzazione: any) {
        this.onChange.emit(autorizzazione);
    }


}
